module.exports = __webpack_public_path__ + "img/icon-close.28732990.svg";